import React from "react";

import styles from "./styles.module.scss";

const tags = ["Diwali Festival", "Live Music", "Events in India", "Holy"];

const Tags = ({ data }) => {
  return (
    <div className={styles.tag__wrapper}>
      <p>Blogs Tags</p>
      <div>
        {tags.map((item, index) => (
          <span key={index}>{item}</span>
        ))}
      </div>
    </div>
  );
};

export default Tags;
